export enum E_LineType {
  solid = 'solid',
  dashed = 'dashed',
  dotted = 'dotted'
}